import { render } from "./SideBarApplicant.vue?vue&type=template&id=e0aa7986"
import script from "./SideBarApplicant.vue?vue&type=script&lang=js"
export * from "./SideBarApplicant.vue?vue&type=script&lang=js"
script.render = render

export default script